import axios from "axios";
import { buildRequestConfig } from "./buildRequestConfig";

const FILES_API_BASE = `${process.env.REACT_APP_API_HOST}/v1/files`;

class FilesUploaderService {
  async initializeFileUpload(params: {
    fileName: string;
    fileId: string;
    contentType: string;
    category: string;
  }) {
    const config = await buildRequestConfig();
    const response = await axios.post(
      `${FILES_API_BASE}/initialize-file-upload`,
      params,
      config
    );
    return response.data.data;
  }

  async createFilePresignedUrls(params: {
    uploadId: string;
    fileKey: string;
    parts: number;
  }) {
    const config = await buildRequestConfig();
    const response = await axios.post(
      `${FILES_API_BASE}/create-file-presigned-urls`,
      params,
      config
    );
    return response.data.data;
  }

  async finalizeFileUpload(params: {
    uploadId: string;
    fileKey: string;
    parts: { PartNumber: number; ETag: string }[];
  }) {
    const config = await buildRequestConfig();
    const response = await axios.post(
      `${FILES_API_BASE}/finalize-file-upload`,
      params,
      config
    );
    return response.data.data;
  }

  async createFileMetadata(params: {
    fileId: string;
    originalFilename: string;
    s3Key: string;
    objectSize: number;
    mimeType: string;
    category: string;
    folderId?: string;
  }) {
    const config = await buildRequestConfig();
    const response = await axios.post(
      `${FILES_API_BASE}/files`,
      params,
      config
    );
    return response.data.data;
  }
}

export const filesUploaderService = new FilesUploaderService();
